export const LOGO_FULL = `${process.env.PUBLIC_URL}/ebs-logo.png`;

export const LOGO_ICON =
  "https://static.prod-images.emergentagent.com/jobs/524e335e-6cd7-4608-a3be-9fe36c78cdf3/images/86368a6d13e3dfed6a34cd66d54257bcb57406ab6e05d681ca4afcfc6db5fd81.png";

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1648747067002-e0872aae5eac?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  massage:
    "https://images.unsplash.com/photo-1745327883508-b6cd32e5dde5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  detailing:
    "https://images.unsplash.com/photo-1708805282706-f44730b7e527?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  about:
    "https://images.unsplash.com/photo-1485217988980-11786ced9454?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const COMING_SOON = [
  {
    name: "Easy Salons",
    image:
      "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    desc: "Bookings, stylists & memberships for hair salons.",
  },
  {
    name: "Easy Nails",
    image:
      "https://images.unsplash.com/photo-1632345031435-8727f6897d53?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    desc: "Effortless appointments for nail bars & studios.",
  },
  {
    name: "Easy Barber",
    image:
      "https://images.unsplash.com/photo-1605497788044-5a32c7078486?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    desc: "Walk-ins, chairs & rosters made simple for barbers.",
  },
  {
    name: "Easy Detailing",
    image:
      "https://images.unsplash.com/photo-1708805282706-f44730b7e527?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    desc: "Job booking & payments for auto detailing & car care.",
  },
  {
    name: "Easy Pet Grooming",
    image:
      "https://images.unsplash.com/photo-1611173622933-91942d394b04?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    desc: "Appointments & reminders for pet grooming salons.",
  },
];

export const EASY_MASSAGE_URL = "https://easymassage.com.au";
